import Slider from 'react-slick';
import css from './ProductSlider.module.scss';
import { Img, Portal, svgSprite } from '../../../../../../../hybrid/wrappers';
import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { useWindowDimensions } from '../../../../../../../common/utils/windowDimensions';
import { checkBrowser, generateUniqueId } from '../../../../../../../common/utils/utils';
import Image from 'next/image';

const VideoModal = ({ video, closeHandler }) => {
    return (
        <Portal closeHandler={closeHandler}>
            <div className={css.modal}>
                <div onClick={closeHandler} className={classNames('circleButton', css.modalClose)}>
                    {svgSprite('cross')}
                </div>
                <video controls>
                    <source src={video?.link} />
                </video>
            </div>
        </Portal>
    );
};

const Status = ({ status, imgidx, idx }) => {
    const width = useWindowDimensions();
    const ref = useRef();
    useEffect(() => {
        const textElement = ref.current;
        if (!textElement) return;
        const parentElement = textElement.parentElement;
        let fontSize = 80; // Початковий розмір шрифту в пікселях

        textElement.style.fontSize = fontSize + 'px';
        // Зменшуємо розмір шрифту, поки текст не поміститься в блок
        while (
            checkBrowser(textElement.scrollWidth) > checkBrowser(textElement.parentElement.getBoundingClientRect().width) * 0.6 ||
            checkBrowser(textElement.scrollHeight) > checkBrowser(textElement.parentElement.getBoundingClientRect().height) * 0.6
        ) {
            fontSize -= 1;
            textElement.style.fontSize = fontSize + 'px';
            parentElement.style.transform = `translate(${idx * 50}%, ${idx * 40}%)`;
        }
    }, [imgidx, width, idx, ref]);

    return (
        <div style={{ zIndex: 5 - idx }} className={css.specialStatusItem}>
            <Image fill src={`/src/img/productStatuses/product-status-${status.type}.svg`} alt={`Status ${status.type}`} />
            <p ref={ref}>{status.name}</p>
        </div>
    );
};

export default function ProductSlider({ sliderImages, dataProduct }) {
    const sliderRef = useRef();
    const [dotIndex, setDotIndex] = useState(0);
    const [dotsToShow, setDotsToShow] = useState(6);
    const [videoModal, setVideoModal] = useState(false);

    const width = useWindowDimensions();

    const arrowClickHandler = (e, type) => {
        e.preventDefault();
        e.stopPropagation();

        if (type === 'prev') {
            const newIndex = dotIndex - 1;
            if (newIndex >= 0) {
                setDotIndex(newIndex);
            }
        } else {
            const newIndex = dotIndex + 1;
            if (newIndex < sliderImages?.length) {
                setDotIndex(newIndex);
            }
        }
    };

    const settings = {
        customPaging: function (i) {
            return (
                <div className={css.dot}>
                    {i === dotIndex && sliderImages?.length > dotsToShow ? (
                        <div
                            onClick={(e) => arrowClickHandler(e, 'prev', i)}
                            className={classNames(css.arrowLeft, { [css.arrowDisabled]: dotIndex === 0 })}
                        >
                            {svgSprite('arrow-left-gt-store')}
                        </div>
                    ) : null}
                    <a>
                        {sliderImages[i]?.collection_name === 'shop-product-video' ? (
                            <div className={css.videoDot}>{svgSprite('play')}</div>
                        ) : null}
                        {sliderImages[i]?.collection_name === 'shop-product-video' ? (
                            <div className={css.videoDotBg}></div>
                        ) : (
                            <img src={sliderImages[i]?.links?.preview} />
                        )}
                    </a>
                    {i - dotIndex + 1 === dotsToShow && sliderImages?.length > dotsToShow ? (
                        <div
                            onClick={(e) => arrowClickHandler(e, 'next', i)}
                            className={classNames(css.arrowRight, {
                                [css.arrowDisabled]: dotIndex + dotsToShow >= sliderImages?.length
                            })}
                        >
                            {svgSprite('arrow-right-gt-store')}
                        </div>
                    ) : null}
                </div>
            );
        },
        appendDots: function (dots) {
            return <ul>{dots.slice(dotIndex, dotIndex + dotsToShow)}</ul>;
        },
        ref: sliderRef,
        dots: true,
        dotsClass: 'productSlider',
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    };

    useEffect(() => {
        if (sliderRef.current) {
            const sliderWidth = sliderRef.current.innerSlider.list?.clientWidth;
            if (sliderWidth) {
                const newDotsToShow = Math.round((sliderWidth - 80) / (64 + 16));
                setDotsToShow(newDotsToShow > 6 ? 6 : newDotsToShow);
            }
        }
    }, [width]);

    return (
        <>
            <div>
                {sliderImages?.length == 0 ? (
                    <div style={{ paddingBottom: 0 }} key={generateUniqueId()} className={css.sliderItem}>
                        <Img className={css.elipse} src='/src/img/store/ProductMainElipse.png' alt='Elipse' />
                        <div className={css.elipseBg}>
                            {dataProduct?.special_statuses && dataProduct?.special_statuses?.length ? (
                                <div className={css.specialStatuses}>
                                    {dataProduct?.special_statuses?.map((status, idx) => (
                                        <Status key={status.id} status={status} imgidx={0} idx={idx} />
                                    ))}
                                </div>
                            ) : null}
                            {svgSprite('product-no-image')}
                        </div>
                    </div>
                ) : (
                    <Slider {...settings}>
                        {sliderImages?.map((img, imgidx) => (
                            <div className={css.sliderItemWrapper} key={generateUniqueId()}>
                                <div className={css.sliderItem}>
                                    {img?.collection_name === 'shop-product-video' ? (
                                        <div onClick={() => setVideoModal(img)} className={css.sliderItemVideo}>
                                            {svgSprite('play')}
                                        </div>
                                    ) : null}
                                    <Image fill className={css.elipse} src='/src/img/store/ProductMainElipse.png' alt='Elipse' />
                                    <div
                                        className={classNames(
                                            css.elipseBg,
                                            img?.collection_name === 'shop-product-video' && css.elipseBgOverflow
                                        )}
                                    >
                                        {dataProduct?.special_statuses && dataProduct?.special_statuses?.length ? (
                                            <div className={css.specialStatuses}>
                                                {dataProduct?.special_statuses?.map((status, idx) => (
                                                    <Status key={status.id} status={status} imgidx={imgidx} idx={idx} />
                                                ))}
                                            </div>
                                        ) : null}
                                        {img?.collection_name === 'shop-product-video' ? (
                                            <video className={css.sliderVideo} src={img.link} />
                                        ) : (
                                            <Image
                                                fill
                                                quality={100}
                                                alt={'Product'}
                                                src={img?.link || img?.links?.card}
                                                className={css.sliderImg}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                )}
            </div>
            {videoModal ? <VideoModal video={videoModal} closeHandler={() => setVideoModal(false)} /> : null}
        </>
    );
}
